<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishBy2Approved.p1')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[8]}}"
      class="member-name"
    >{{news.textParams[9]}}</router-link>
    {{$t('news.template.proposal.publishBy2Approved.p2')}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{news.textParams[4]}}
    </router-link>
    {{$t('news.template.proposal.publishBy2Approved.p3')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}">
      {{news.textParams[6]}}
    </router-link>.
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}">
      {{news.textParams[6]}}
    </router-link>
    {{$t('news.template.proposal.publishBy2Approved.p4')}}
    {{news.textParams[7]}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{news.textParams[4]}}
    </router-link>
    {{$t('news.template.proposal.publishBy2Approved.p5')}}
  </div>
</template>
